import { render, staticRenderFns } from "./RedesNavbar.vue?vue&type=template&id=ed3812ce&scoped=true"
import script from "./RedesNavbar.vue?vue&type=script&lang=js"
export * from "./RedesNavbar.vue?vue&type=script&lang=js"
import style0 from "./RedesNavbar.vue?vue&type=style&index=0&id=ed3812ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3812ce",
  null
  
)

export default component.exports